<div class="page">
  <h1>{{ "Gear renaming proposals" | translate }}</h1>
  <small>
    {{
      "AstroBin would like to rename some of your gear items in order to be more consistent with naming conventions."
        | translate
    }}
  </small>

  <astrobin-nothing-here *ngIf="proposals.length === 0; else hasProposals"></astrobin-nothing-here>
</div>

<ng-template #hasProposals>
  <div class="alert alert-info">
    <fa-icon icon="info-circle"></fa-icon>
    {{
      "If you have personal notes that you wish to attach to equipment items, you will be able to do it later on. " +
        "That fact should not be a reason to reject a renaming proposal by itself." | translate
    }}
  </div>

  <table *ngIf="proposals.length > 0" class="table">
    <caption>
      {{
        "Gear renaming proposals" | translate
      }}
    </caption>
    <colgroup>
      <col class="old" span="2" />
      <col />
      <col class="new" span="3" />
    </colgroup>
    <thead>
      <tr>
        <th>{{ "Old brand/make" }}</th>
        <th>{{ "Old name" }}</th>
        <th></th>
        <th>{{ "New brand/make" }}</th>
        <th>{{ "New name" }}</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let proposal of proposals"
        [class.approved]="proposal.status === GearRenamingProposalStatus.APPROVED"
        [class.rejected]="proposal.status === GearRenamingProposalStatus.REJECTED"
      >
        <td>{{ proposal.oldMake }}</td>
        <td>{{ proposal.oldName }}</td>
        <td>&xrarr;</td>
        <td>{{ proposal.newMake }}</td>
        <td>
          {{ proposal.newName }}
          <span *ngIf="proposal.modified" class="modified">
            {{ "(modified)" | translate }}
          </span>
        </td>
        <td>
          <button
            [class.loading]="this.loadingService.loading$ | async"
            [disabled]="proposal.status !== GearRenamingProposalStatus.PENDING"
            (click)="approve($event, proposal)"
            class="btn btn-xs btn-success mb-2 mb-md-0 me-lg-2"
          >
            <fa-icon class="d-none d-lg-inline" icon="check"></fa-icon>
            {{ "Approve" | translate }}
          </button>
          <button
            [class.loading]="this.loadingService.loading$ | async"
            [disabled]="proposal.status !== GearRenamingProposalStatus.PENDING"
            (click)="reject($event, proposal)"
            class="btn btn-xs btn-danger"
          >
            <fa-icon class="d-none d-lg-inline" icon="times"></fa-icon>
            {{ "Reject" | translate }}
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="alert alert-warning responsive-notice">
    {{ "Please use a device with a minimum horizontal resolution of 1024 pixels to view this content." | translate }}
  </div>
</ng-template>
